module.exports = __webpack_public_path__ + "img/fruit-blueberries-190x100.d6189c1a.jpg";